var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"layout-wrapper"}},[_c('HorizontalTopbar',{attrs:{"width":_vm.layoutWidth,"type":_vm.topbar}}),_c('HorizontalNav'),_c('div',{staticClass:"main-content"},[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"container-fluid"},[_vm._t("default")],2)]),_c('Footer')],1),_c('RightBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }